import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import { LookupCursadasAlumnos } from '../Cursadas/LookupCursadasAlumnos';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';
import {
  classifyInscripcionesError,
  toUpdateInscripcionCursadaPayload,
} from '../../services/inscripciones/inscripcionesDto';

function getPeriodoCursada(periodoCursadaDescripcion) {
  if (periodoCursadaDescripcion === '1') return 'Primer Cuatrimestre';
  if (periodoCursadaDescripcion === '2') return 'Segundo Cuatrimestre';
  return 'Anual';
}

function getEstadoInscripcion(estado) {
  if (estado === 'A') return 'Activa';
  if (estado === 'P') return 'Pendiente';
  if (estado === 'G') return 'Acta Generada';
  return 'Lista';
}

export class UpdateInscripcionCursadaAlumno extends Component {
  static displayName = UpdateInscripcionCursadaAlumno.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupCursada: false,
      cursada: {
        cursadaCodigo: 0,
        cursadaMateriaCodigo: '',
        cursadaMateriaNombre: '',
        cursadaPeriodo: '',
      },
      alumno: {
        alumnocarreraCod: 0,
        alumnoNombre: '',
        alumnoCarrera: 0,
        alumnoCarreraNombre: '',
      },
      descripcion: '',
      id: this.props.match.params.id,
      details: this.props.match.params.details,
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('InscribirCursada');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (this.state.details === '1') {
      this.setState({ success: true });
      return;
    }

    if (!this.isOkToSave()) {
      this.setState({ showErrorMessage: true, errorMessage: 'Todos los campos son obligatorios' });
      return;
    }

    this.saveStudent();
  };

  async populateData() {
    try {
      const data = await inscripcionesService.getInscripcionCursada(this.state.id);
      this.setState({
        errorMessage: '',
        cursada: {
          cursadaCodigo: data.cursadaCod,
          cursadaMateriaCodigo: data.cursadaCodNavigation.materiaCarreraCod,
          cursadaMateriaNombre: data.cursadaCodNavigation.materiaNombre,
          cursadaPeriodo: getPeriodoCursada(data.cursadaCodNavigation.periodoCursadaDescripcion)
            + ' - '
            + data.cursadaCodNavigation.anioAcademicoDescripcion,
        },
        alumno: {
          alumnocarreraCod: data.alumnoxCarreraCodNavigation.alumnoxCarreraCod,
          alumnoNombre: data.alumnoxCarreraCodNavigation.alumnoNombre,
          alumnoCarrera: data.alumnoxCarreraCodNavigation.carreraCod,
          alumnoCarreraNombre: data.alumnoxCarreraCodNavigation.carreraNombre,
        },
        descripcion: data.inscripcionCursadaEstado,
      });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({ errorMessage: outcome.message });
    }
  }

  handleShowCursadaLookup = () => {
    this.setState({ showLookupCursada: true });
  };

  handleHideLookup = () => {
    this.setState({ showLookupCursada: false });
  };

  handleCursadaAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      cursada: {
        cursadaCodigo: anioProperties[0],
        cursadaMateriaCodigo: anioProperties[4],
        cursadaMateriaNombre: anioProperties[1],
        cursadaPeriodo: getPeriodoCursada(anioProperties[2]) + ' - ' + anioProperties[3],
      },
      showLookupCursada: false,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-ica" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de Inscripción a Cursada' : 'Modificar Inscripción a Cursada';
    const { loading } = this.state;
    const alumnoDisplay = this.state.alumno.alumnoNombre.trim();
    const cursadaDisplay = (this.state.cursada.cursadaMateriaNombre.trim() + ' - ' + this.state.cursada.cursadaPeriodo).trim();
    const estadoLabel = getEstadoInscripcion(this.state.descripcion);

    return (
      <div className="md-page md-update-ica">
        <Link className="md-page__back-link" to="/md-ica">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados de su inscripción a cursada.'
            : 'Actualice la materia inscripta y guarde los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {this.state.errorMessage && !this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno</span>
            <div className="md-page__field-readonly">{alumnoDisplay}</div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Materia</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCursadaLookup}>
                  Seleccionar la materia
                </button>
              ) : null}
              <div className="md-page__field-readonly">{cursadaDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Estado de la inscripción</span>
            <div className="md-page__field-readonly">{estadoLabel}</div>
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={loading}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookupCursada ? (
          <LookupCursadasAlumnos
            alumnoCarreraCod={this.state.alumno.alumnocarreraCod}
            carreraCod={this.state.alumno.alumnoCarrera}
            selectItem={this.handleCursadaAnioItem}
            hideLookup={this.handleHideLookup}
          />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return this.state.descripcion.length > 0;
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await inscripcionesService.updateInscripcionCursada(toUpdateInscripcionCursadaPayload({
        id: this.state.id,
        cursadaCod: this.state.cursada.cursadaCodigo,
        alumnoxCarreraCod: this.state.alumno.alumnocarreraCod,
        materiaCarreraCod: this.state.cursada.cursadaMateriaCodigo,
        estado: this.state.descripcion,
        ignorarCorrelatividad: false,
      }));
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
